var _rect, _rect2, _rect3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtratoEscuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 108,
    rx: 9,
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 84.3038,
    height: 12.1212,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 82.8788,
    width: 56.962,
    height: 12.1212,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 48.9394H66.962V61.0606H10V48.9394Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4805 71.1953C84.3998 69.8047 82.7659 68.367 82.7659 66.1279C82.7659 63.5589 85.0265 61.7677 88.809 61.7677C92.793 61.7677 94.2702 63.771 94.4045 66.7172H99.3509C99.1942 62.6633 96.8441 58.9394 92.1663 57.7374V52.5758H85.4517V57.6667C81.1096 58.6566 77.6181 61.6263 77.6181 66.1751C77.6181 71.6195 81.893 74.33 88.1376 75.9091C93.7331 77.3232 94.8521 79.3973 94.8521 81.5892C94.8521 83.2155 93.7554 85.8081 88.809 85.8081C84.1983 85.8081 82.3854 83.6397 82.1392 80.8586H77.2152C77.4838 86.0202 81.1544 88.9192 85.4517 89.8855V95H92.1663V89.9327C96.5308 89.0606 100 86.3973 100 81.5657C100 74.8721 94.5612 72.5859 89.4805 71.1953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtratoEscuro);
export default __webpack_public_path__ + "static/media/ExtratoEscuro.da12b8afb6146205754f9aee220e88f4.svg";
export { ForwardRef as ReactComponent };